"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nConfigurationProvider = void 0;
const i18n_configuration_1 = require("./data/i18n-configuration");
/**
 * Accessor class to retrieve I18n Configurations.
 */
class I18nConfigurationProvider {
    /**
     * Retrieves the requested configuration.
     *
     * @param name Name of the specific configuration to query.
     * @param args Input parameters used to resolve the query.
     *
     * @return Resolved configuration query QueryOutput. If the configuration query did not return a QueryOutput
     *          an empty I18nConfiguration should be returned.
     *
     * @throwns Error when config and args type doesn't match or the resolver is not registered.
     */
    getConfiguration(name, args) {
        this.validate(name, args);
        let configuration;
        try {
            configuration = this.resolveConfiguration(name, args);
        }
        catch (error) {
            console.warn(`Failed to resolve configuration query with name ${name.toString()} and args ${args.toString()}. Error: ${error}`);
            // return empty configuration in case of an error
            configuration = new i18n_configuration_1.I18nConfiguration.Builder().build();
        }
        return configuration;
    }
    /**
     * Retrieves the requested configuration with stage.
     *
     * @param name Name of the specific configuration to query.
     * @param args Input parameters used to resolve the query.
     * @param configStage The configStage used to retrieve configuration
     *
     * @return Resolved configuration query QueryOutput. If the configuration query did not return a QueryOutput
     *          an empty I18nConfiguration should be returned.
     *
     * @throwns Error when config and args type doesn't match or the resolver is not registered.
     */
    getConfigurationWithStage(name, args, configStage) {
        this.validate(name, args);
        let configuration;
        try {
            configuration = this.resolveConfigurationWithStage(name, args, configStage);
        }
        catch (error) {
            console.warn(`Failed to resolve configuration query with name ${name.toString()}, stage ${configStage} and args ${args.toString()}. Error: ${error}`);
            // return empty configuration in case of an error
            configuration = new i18n_configuration_1.I18nConfiguration.Builder().build();
        }
        return configuration;
    }
    /**
     * Resolves the requested configuration into a query Result.
     * The input is already validated as part of getConfiguration.
     *
     * @param name Name of the specific configuration to query.
     * @param args Input parameters used to resolve the query.
     * @param configStage The configStage used to retrieve configuration
     *
     * @return Resolved configuration query QueryOutput. If the configuration query did not return a QueryOutput
     *          an empty I18nConfiguration should be returned.
     *
     * @throws Error    Thrown if there is no Resolver registered to resolve the query
     */
    resolveConfigurationWithStage(name, args, configStage) {
        throw new Error("Method resolveConfigurationWithStage is not implemented!");
    }
    ;
    /**
     * Validates that the passed arguments belong to the same or related Config Type.
     * If a miss-match is detected an Error is thrown
     *
     * @param name Name of the specific configuration to query.
     * @param args Input parameters used to resolve the query.
     *
     * @throws Error Thrown if miss-match in argument type is detected.
     */
    validate(name, args) {
        const matchDetected = (name.getConfigType() === args.getConfigType() ||
            (args.getConfigType().parent !== undefined && name.getConfigType() === args.getConfigType().parent));
        if (!matchDetected) {
            throw new Error(`Input query args type need to match the config name type.` +
                `Found ${name.getConfigType()} for config name, but ${args.getConfigType()} for config args.`);
        }
    }
}
exports.I18nConfigurationProvider = I18nConfigurationProvider;
//# sourceMappingURL=i18n-configuration-provider.js.map